import { makeStyles } from '@material-ui/core';
import Alert from '@material-ui/lab/Alert';
import { ApiError } from './types';

const useStyles = makeStyles(theme => ({
  errorContainer: {
    marginTop: theme.spacing(2),
  },
  errorDetails: {
    marginTop: theme.spacing(1),
    fontSize: '0.9em',
  },
}));

interface ErrorDisplayProps {
  error: ApiError | null;
}

export const ErrorDisplay: React.FC<ErrorDisplayProps> = ({
  error,
}) => {
  const classes = useStyles();

  if (!error) {
    return null;
  }

  return (
    <div className={classes.errorContainer}>
      <Alert 
        severity= 'error'
        style={{ marginBottom: '8px' }}
      >
        <strong>{error.message}</strong>
        {error.details && (
          <div className={classes.errorDetails}>
            {error.details}
          </div>
        )}
      </Alert>
    </div>
  );
};
